import styled from 'styled-components'

export const OptionsList = styled.ul`
  position: absolute;
  top: 2.5rem;
  right: 1rem;
  list-style: none;
  padding: 0;
  margin: 0;
  background-color: #FFF;
  border-radius: .5rem;
  z-index: 1;
  box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.2);
`

export const Option = styled.li`
  padding: .8rem;
  cursor: pointer;
  user-select: none;
  color: #696969;
  display: flex;
  align-items: center;
  gap: 1rem;

  &:hover {
    background-color: #EBEBEB;
  }
`